import axios from "axios";
import { showToast } from "../components/util/util";
import { logout, token, setToken } from "../authentication/authorizer";
import { getSessionKeyId } from "../authentication/authorizer";

function handleNetworkError(route, error, onFailure, onRefreshToken) {
  try {
    const { status, data } = error.response;
    var exceptionMessage = data.exceptionMessage
    if (exceptionMessage === null || exceptionMessage === undefined) {
      exceptionMessage = data.error
    }
    if (exceptionMessage === null || exceptionMessage === undefined) {
      exceptionMessage = "خطای ناشناخته"
    }
    if (status === 500){
      showToast("error","خطای 500 - خطای داخلی سرور");
    }
    if (status === 400) {
      if (route === `auth/refresh`) {
        logout();
      }
      showToast("error", exceptionMessage);
      onFailure();
    } else if (status === 403) {
      if (route === `auth/refresh`) {
        logout();
      }
      showToast("error", route + " - شما به این بخش دسترسی ندارید.");
    } else if (status === 401) {
      if (route === `auth/refresh`) {
        logout();
        showToast("error", exceptionMessage);
      } else {
        refreshToken(onRefreshToken);
      }
    } else {
      onFailure(exceptionMessage)
    }
  } catch (err) {
    onFailure()
  }
}

/****
 * AUTHENTICATION
 */

export function authorize(mobile, deviceUniqueId, deviceName, os, osVersion, onSuccess, onFailure) {
  var route = `auth/authorize`
  axios
    .post(
      route,
      {
        mobile: mobile,
        deviceUniqueId: deviceUniqueId,
        deviceName: deviceName,
        os: os,
        osVersion: osVersion,
        platform: `SITE`
      },
      { withCredentials: true }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () { });
    });
}

export function verifyOtp(code, sessionKeyId, onSuccess, onFailure) {
  var route = `auth/verifyOtp`
  axios
    .post(
      route,
      {
        code: code,
        sessionKeyId: sessionKeyId
      },
      { withCredentials: true }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () { });
    });
}

export function refreshToken(onRefreshToken) {
  var route = `auth/refresh`
  axios
    .post(
      route,
      {
        token: token(),
        sessionKeyId: getSessionKeyId()
      },
      { withCredentials: true }
    )
    .then((response) => {
      if (response.data.data.token !== null && response.data.data.token !== undefined && response.data.data.expirationTime !== null && response.data.data.expirationTime !== undefined)
        setToken(response.data.data.token, response.data.data.expirationTime)
      if (onRefreshToken !== null && onRefreshToken !== undefined)
        onRefreshToken()
    })
    .catch((error) => {
      handleNetworkError(route, error, function () { }, function () { });
    });
}

export function terminateSession(sessionKeyId, onSuccess, onFailure) {
  var route = `auth/terminateSession`
  axios
  .post(
    route,
    {
      sessionKeyId: sessionKeyId
    },
    {
      headers: {
        Authorization: token(),
      },
      withCredentials: true,
    }
  )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        terminateSession(sessionKeyId, onSuccess, onFailure)
      });
    });
}

export function getProfile(onSuccess, onFailure) {
  var route = `profile/get`
  axios
    .get(
      route,
      {
        headers: {
          Authorization: token(),
        }, withCredentials: true
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        getProfile(onSuccess, onFailure)
      });
    });
}

export function releaseHome(onSuccess, onFailure) {
  var route = `release/home`
  axios
    .get(
      route,
      {
        headers: {
          Authorization: token(),
        }, withCredentials: true
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        releaseHome(onSuccess, onFailure)
      });
    });
}

export function releaseDetail(id, onSuccess, onFailure) {
  var route = `release/detail?id=${id}`
  axios
    .get(
      route,
      {
        headers: {
          Authorization: token(),
        }, withCredentials: true
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        releaseDetail(id, onSuccess, onFailure)
      });
    });
}

export function releaseNote(id, onSuccess, onFailure) {
  var route = `release/releaseNote?id=${id}`
  axios
    .get(
      route,
      {
        headers: {
          Authorization: token(),
        }, withCredentials: true
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        releaseNote(id, onSuccess, onFailure)
      });
    });
}

export function releaseList(
  size,
  index,
  sortBy,
  sortType,
  keyword,
  filters,
  onSuccess,
  onFailure
) {
  var route = `release/list`
  axios
    .post(
      route,
      {
        size: size,
        index: index,
        keyword: keyword,
        sortBy: sortBy,
        sortType: sortType,
        filters: filters,
      },
      {
        headers: {
          Authorization: token(),
        },
        withCredentials: true,
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        releaseList(
          size,
          index,
          sortBy,
          sortType,
          keyword,
          filters,
          onSuccess,
          onFailure
        )
      });
    });
}

export function linkageList(onSuccess, onFailure) {
  var route = `linkage/list`
  axios
    .get(
      route,
      {
        headers: {
          Authorization: token(),
        }, withCredentials: true
      }
    )
    .then((response) => {
      onSuccess(response.data.data);
    })
    .catch((error) => {
      handleNetworkError(route, error, onFailure, function () {
        linkageList(onSuccess, onFailure)
      });
    });
}